/**
 * Seqirus Flu Vaccine Study - Self-Contained Module
 *
 * This module contains all configuration for the Seqirus Flu Vaccine Study
 * in a single, easily maintainable location.
 */

import { defineStudy } from "./registry";
import { seqirusEligibleZipCodes } from "../../../data/vaccine-study-zipcodes/seqirusZipCodes";
import { sequirisFluVaccineScreeningQuestions } from "../../../data/pre-screener-config/SequirisFluVaccineScreener";

/**
 * Common question IDs that will be asked before zipcode
 * and should be filtered out of study-specific questions
 */
const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Seqirus Flu Vaccine Study
 *
 * Priority: 2 (Lower priority - checked after Cidara)
 * Trial ID: VFLUV11824
 * Location: Specific zipcodes in multiple states
 *
 * Key criteria:
 * - Age 65+
 * - No recent flu vaccine (within 6 months)
 * - No history of Guillain-Barré syndrome
 * - No allergic reactions to flu vaccine
 */
export const seqirusFluVaccineStudy = defineStudy({
  id: "seqirus",
  name: "Seqirus Flu Vaccine Study",
  trialId: "VFLUV11824",
  priority: 2,

  // Convert readonly array to regular array for compatibility
  eligibleZipCodes: Array.from(seqirusEligibleZipCodes),

  // All questions including common ones (will be filtered automatically)
  questions: sequirisFluVaccineScreeningQuestions,

  // Questions to filter out (already asked in common stage)
  commonQuestionIds: COMMON_QUESTION_IDS,

  // Required common answer values (age 65+)
  commonAnswerRequirements: {
    age_eligibility: ["65_or_older"],
  },

  metadata: {
    sponsor: "Seqirus",
    description:
      "Evaluating the effectiveness, safety, and immune response of an investigational flu vaccine in adults aged 65 and older",
  },
});
